const N = '\n';
const TAB = '\t';
const F = '\f';
const R = '\r';

const EQ = '=';
const QUOTEMARK = '"';
const SPACE = ' ';

const OPEN_BRAKET = '[';
const CLOSE_BRAKET = ']';

const SLASH = '/';
const BACKSLASH = '\\';

export { N, F, R, EQ, TAB, SPACE, SLASH, BACKSLASH, QUOTEMARK, OPEN_BRAKET, CLOSE_BRAKET };
